import React, { useState, forwardRef, ForwardedRef } from 'react';
import { Typography, Box, alpha, useTheme, Skeleton, Tooltip } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home'; 
import { useEasyBrowserContext } from '../../browser';

const MenuPrincipalTaskBar = forwardRef((_props: unknown, _ref: ForwardedRef<any>) => {
    const { abrirPagina } = useEasyBrowserContext()!;
    const theme = useTheme();
    const [imageError, setImageError] = useState(false);
    const [loading, setLoading] = useState(true);

    const paginaMenu = {
        id: 'easy.schedule.menu.principal',
        descricao: 'Menu Principal',
        url: '/menu/menu',
        icone: "MenuIcon",
        grupo: ['principal'],
        licenca: ['GERAL']
    };

    return (
        <Tooltip title="Menu Principal" arrow disableInteractive enterDelay={500}>
            <Box
                ref={_ref}
                onClick={() => abrirPagina(paginaMenu)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '40px',
                    px: 1.5,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    userSelect: 'none',
                    '&:hover': {
                        bgcolor: alpha(theme.palette.primary.main, 0.08),
                        transform: 'scale(1.02)',
                    },
                    '&:active': {
                        transform: 'scale(0.98)',
                        bgcolor: alpha(theme.palette.primary.main, 0.15),
                    },
                }}
            >
                <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    
                    {/* Skeleton proporcional ao espaço esperado */}
                    {loading && !imageError && (
                        <Skeleton 
                            variant="rectangular" 
                            width={140} 
                            height={28} 
                            sx={{ borderRadius: 1 }} 
                        />
                    )}

                    {!imageError ? (
                        <img
                            src="/AppCodesh.png"
                            alt="Logo App Codesh"
                            style={{
                                height: '32px', // Altura definida, largura automática para não espremer
                                width: 'auto',
                                maxWidth: '180px', // Limite máximo para não invadir as abas
                                objectFit: 'contain', // Garante que caiba no espaço sem distorcer
                                display: loading ? 'none' : 'block',
                                filter: theme.palette.mode === 'dark' ? 'brightness(1.2)' : 'none'
                            }}
                            onLoad={() => setLoading(false)}
                            onError={() => {
                                setImageError(true);
                                setLoading(false);
                            }}
                        />
                    ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <HomeIcon sx={{ color: theme.palette.primary.main }} />
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 800,
                                    fontSize: '1.1rem',
                                    color: theme.palette.primary.main,
                                    letterSpacing: '-0.5px'
                                }}
                            >
                                CODESH
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Tooltip>
    );
});

MenuPrincipalTaskBar.displayName = 'MenuPrincipalTaskBar';

export default MenuPrincipalTaskBar;